import { breakpoints } from '@bnnvara/breakpoints';
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

import { AUDIO_TYPE } from '../MediaPlayer/types';

export const NPOLink = styled.p`
  font-size: 16px;
  height: 100%;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  ${breakpoints.md} {
    font-size: 18px;
  }

  ${breakpoints.lg} {
    font-size: 20px;
  }

  a {
    color: red;
  }
`;

export const Iframe = styled.iframe`
  height: ${(props) => (props.type === AUDIO_TYPE ? '50px' : '100%')};
`;
